import { Button } from '@chegg-ui/button'
import { showCheggAuthModal } from '@src/state/auth/actions'
import { getLoggedIn } from '@src/state/auth/selectors'
import { RootState } from '@src/state/types'
import media, { PHONE_DOUBLE_ZOOM } from '@src/styled/media'
import * as React from 'react'
import { connect } from 'react-redux'
import { AnyAction, Dispatch } from 'redux'
import styled from 'styled-components'
import PapersTable from './PapersTable'

interface PapersSectionStateProps {
  loggedIn: boolean
}

interface PapersSectionDispatchProps {
  handleSignin: () => void
}

type PapersSectionProps = PapersSectionStateProps & PapersSectionDispatchProps

type SignedOutProps = Pick<PapersSectionProps, 'handleSignin'>

export const SIGNED_OUT_COPY = 'Sign in to see your papers'
export const SIGNED_OUT_CTA = 'Sign in'
export const SIGN_IN_BUTTON = 'signInButton'

export const PAPERS_SECTION_SIGNIN = 'footer-signin'

const SignInButton = styled(Button).attrs({ size: 'medium' })`
  ${media[PHONE_DOUBLE_ZOOM]`
    max-width: 70vw;
  `}
`

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: ${({ theme }) => `${theme.spacing.xl}`};
  margin-bottom: ${({ theme }) => `${theme.spacing.xl}`};
  padding-top: ${({ theme }) => `${theme.spacing.xl}`};
  padding-bottom: ${({ theme }) => `${theme.spacing.xl}`};
`

const SignedOutFooter: React.FunctionComponent<SignedOutProps> = ({ handleSignin }) => {
  return (
    <Container>
      <p>{SIGNED_OUT_COPY}</p>
      <SignInButton onClick={handleSignin} data-test={SIGN_IN_BUTTON}>
        {SIGNED_OUT_CTA}
      </SignInButton>
    </Container>
  )
}

export const PapersSection: React.FunctionComponent<PapersSectionProps> = ({
  loggedIn,
  handleSignin,
}) => (
  <div>
    {loggedIn ? (
      <>
        <PapersTable />
      </>
    ) : (
      <SignedOutFooter handleSignin={handleSignin} />
    )}
  </div>
)

const mapStateToProps = (state: RootState) => ({
  loggedIn: getLoggedIn(state),
})

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => ({
  handleSignin: () =>
    dispatch(showCheggAuthModal({ experience: 'login', origin: PAPERS_SECTION_SIGNIN })),
})

export default connect<PapersSectionStateProps, PapersSectionDispatchProps>(
  mapStateToProps,
  mapDispatchToProps
)(PapersSection)



// WEBPACK FOOTER //
// ./src/pages/MyPapers/PapersSection.tsx